import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';

export const TherapistPlanningLoadable = loadable(async () => import('./therapist-planning.view'), {
  fallback: <FullPageLoading />,
});

export const TherapistPlanningOnboardingLoadable = loadable(async () => import('./therapist-planning.onboarding'));
